import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { store } from './store';
import { Task, activeOrderType, initialElement, uploadFileType, workflowSubTask } from '../api/types';

export default class ElementStore {
  // activityRegistry = new Map <string, Activity>();
  selectedWFTask: Task = {
    taskId: '',
    taskIndex: 0,
    icon: '',
    taskName: '',
    username: '',
    templateTaskId: '',
    status: '',
    taskDateTime: '',
    isCurrentTask: false,
    isActive: false,
    isDeleted: false,
    subTasks: [],
  };
  selectedWFSubTask: string = '';
  taskCounts: {
    totalTaskActiveCount: number;
    completeTaskActiveCount: number;
  } = {
    totalTaskActiveCount: 0,
    completeTaskActiveCount: 0,
  };
  loading = false;
  loadingInitial = false;
  activeSubTas: any;
  activeSubTasInd: any;
  getResolveId = {
    id: '',
    name: '',
  };
  getResolvedId = {
    id: '',
    name: '',
  };
  storeCurrSubtask: any;
  loadAllDatas: any;
  loadAllTaskandSubTask: any;
  setGetMethodClicked: boolean = false;
  kanbanTiggerbutton: boolean = false;
  NFAIReelanalysisArr: any[] = [];

  workflowSubTask: workflowSubTask = {
    subTaskId: "",
    subtaskIndex: 0,
    subTaskName: "",
    subTaskDateTime: "",
    autoRejectTo: null,
    isFinish: false,
    isActive: false,
    isDeleted: false,
    isCurrentSubtask: false,
    tATTime: 0,
    startSTDate: "",
    endSTDate: "",
    subTaskstatus: 0,
    status: 0,
    recVersion: "",
    templateSubtaskId: "",
    actionerName: null,
    elements: [initialElement],
    files: [],
    communication: [],
    api: [],
  };
  workflowSubTaskLoader:boolean=false;

  constructor() {
    makeAutoObservable(this);
  }

  getTotalCountsOfTask = async (id: string) => {
    try {
      let counts = await agent.Elements.getUpdateTaskCountAPI(
        id || '00000000-0000-0000-0000-000000000000',
      );
      runInAction(() => {
        this.taskCounts = counts.data;
      });
    } catch (error) {
      toast.error('Pls Try Again !');
    }
  };

  collectActiveSubTas = (data: any) => {
    this.activeSubTas = data;
  };

  getActiveSubtaskInd = (data: any) => {
    this.activeSubTasInd = data;
  };

  selectResolveSubtask = (data: { id: string; name: string }) => {
    this.getResolveId = data;
  };

  triggerResolve = (data: { id: string; name: string }) => {
    this.getResolvedId = data;
  };

  storeCurrentSubtask = (data: any) => {
    this.storeCurrSubtask = data;
  };

  uploadFilesSubTask = async (data: any, subTaskIdNo: any) => {
    try {
      let result = await agent.workflowSubtasks.uploadFiles(data, subTaskIdNo);

      runInAction(() => {
        toast.success('Element Updated');
        return result;
      });
    } catch {
      toast.error('Element failed to update. Please try again');
    }
  };

  generatePdf = async (payload: uploadFileType) => {
    try {
      
      await agent.Activities.digitalUpdateFile(payload);
      runInAction(() => {
        toast.success('Files added successfully.');
      });
    } catch (error) {
      toast.error('File(s) failed to be added.');
    }
  };

  HFCgeneratePdf  = async (payload: uploadFileType) => {
    try {
      
      await agent.Activities.HFCDigitalUpdateFile(payload);
      runInAction(() => {
        toast.success('Files added successfully.');
      });
    } catch (error) {
      toast.error('File(s) failed to be added.');
    }
  };

  postAPITemp = async (
    id: string,
    itemId: string,
    SubTkStatus: string | null,
  ) => {
    try {
      const Response = await agent.workflowStatus.sendAPITemp(
        id,
        itemId,
        SubTkStatus,
      );
      store.viewStore.getActiveOrder({ itemId });
      runInAction(() => {
        if (!Array.isArray(Response?.data)) {
          if (Response.data?.includes('Applied validation failed')) {
            toast.warning(Response.data);
            store.commonStore.updateHistoryAlonePOST(
              `WARNING !!! ${Response.data} Entry done by ${store.userStore.user?.displayName}`,
              store.activityStore.selectedActivity?.id,
            );
          } else if (Response.data?.includes('Cannot complete')) {
            //NFAI
            toast.warning(Response.data);
            store.commonStore.updateHistoryAlonePOST(
              `${Response.data} Entry done by ${store.userStore.user?.displayName}`,
              store.activityStore.selectedActivity?.id,
            );
            setTimeout(() => {
              store.viewStore.viewPageHistoryAlone({
                itemId: store.activityStore.selectedActivity?.id,
                pageNo: 1,
                pageSize: 4,
              });
            }, 300);
          } else {
            toast.success('API triggered Successfully');
          }
        }
      });
      return Response.status;
    } catch (error) {
      console.log(error);
    }
  };

  postCommunicationTemp = async (id: string) => {
    try {
      await agent.workflowStatus.sendCommunicationTemp(id);
      // runInAction(() => {
      //   toast.success('Email sent Successfully');
      // });
    } catch (error) {
      console.log(error);
    }
  };
  setSelectedTask = (task: Task) => {
    this.selectedWFTask = task;
  };
  setSelectedSubTask = (subtask: string) => {
    this.selectedWFSubTask = subtask;
  };
  // workflowMetaData
  loadAllworkflowmetadata = async (id: string) => {
    try {
      const metadatadetails = await agent.workflowStatus.workflowMetaData(id);
      runInAction(() => {
        this.loadAllDatas = metadatadetails;
      });
      return metadatadetails;
    } catch (error) {
      console.log(error);
    }
  };

  updateElementToggle = async (
    data: activeOrderType,
    actid: string,
    totalTaskActiveCount: number,
    completeTaskActiveCount: number,
  ) => {
    try {
      await agent.Elements.updateElement(
        data,
        totalTaskActiveCount,
        completeTaskActiveCount,
      );
      store.viewStore.viewPageHistory({
        itemId: store.activityStore.selectedActivity!.id,
        pageNo: 1,
        pageSize: 4,
      });
      toast.success('Edited Element Successfully');
    } catch (error) {
      console.log(error);
    }
  };

  loadAllWorkflowTaskAndSubTask = async (id: string) => {
    try {
      const tasksubtaskdetails = await agent.workflowStatus.communication(id);
      runInAction(() => {
        this.loadAllTaskandSubTask = tasksubtaskdetails;
      });
      return tasksubtaskdetails;
    } catch (error) {
      console.log(error);
    }
  };
  Kanban_model_Mute_button = (data: boolean) => {
    try {
      this.kanbanTiggerbutton = data;
    } catch (error) {
      console.log(error);
    }
  };

  HandleWorkflowSubtaskApi = async (itemId:string)=>{
    try {
      this.workflowSubTaskLoader = true;
      const response  = await agent.subtaskStatus.subtaskElementsAPI(itemId);
      runInAction(()=>{
           this.workflowSubTask  = response.data;
           this.workflowSubTaskLoader = false;
      })
    } catch (error) {
      this.workflowSubTaskLoader = false;
      toast.error('workflow subtask failed...');
    }
  }
}
